import React from 'react';

import Card from '../../components/Card/Card';

import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';

import { MARKET_DATA } from './queries';
import { marketDataUtil } from './util';

import styles from './MarketData.css';

const MarketData = ({ ticker }) => (
    <Card className="left">
        <GqlQueryWrapper
            query={MARKET_DATA}
            variables={{ ticker }}
            dataFunc={marketDataUtil(ticker)}
            placeholder={() => <TablePreRender />}
        >
            {({ data: { data, asOfDate } }) => (
                <React.Fragment>
                    <div className="subsection-no-border">
                        <TitleWithDescription
                            borderLine
                            title="Market Data"
                            rightText={() => `As of ${asOfDate}`}
                        />
                        <Table data={{ data }} labelSpecificTooltips />
                    </div>
                </React.Fragment>
            )}
        </GqlQueryWrapper>

        <style jsx>{styles}</style>
    </Card>
);

export default MarketData;
